import React, { useState } from "react";
import { Button } from "components/shadcn/ui/button";
import { Input } from "components/shadcn/ui/input";

interface Props {
  onSend: (message: string) => void;
  sending: boolean;
}

const ThreadMessageInput: React.FC<Props> = ({ onSend, sending }) => {
  const [message, setMessage] = useState("");

  const handleSend = () => {
    onSend(message);
    setMessage("");
  };

  return (
    <div className="p-3 border-t bg-white flex gap-2  rounded-xl h-full items-center w-[95%]">
      <Input
        placeholder="Type a message..."
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && handleSend()}
        className="h-full focus:outline-none"
      />
      <Button
        variant="primary"
        onClick={handleSend}
        disabled={sending || !message.trim()}
      >
        Send
      </Button>
    </div>
  );
};

export default ThreadMessageInput;
